import { ToggleOauthIntegration } from '@/connection/integrations/oauth';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const toggleOauthIntegrationReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, uuid, on }: { channel: number; uuid: string; on: boolean }, { rejectWithValue }) => {
      try {
        const isOn = await ToggleOauthIntegration(channel, uuid, on);
        return isOn;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state) => {
        if (state.oauthIntegration) {
          state.oauthIntegration = { ...state.oauthIntegration, active: !state.oauthIntegration.active };
        }
      },
    }
  );
};

export default toggleOauthIntegrationReducer;
